








import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getLicenses } from '@/services/licenses';
import { Localization } from '@/services/localization';

@Component
export default class Licenses extends Vue {
  private displayLicenses = false;
  private thirdPartySoftware = '';

  locale(translationKey: string) {
    return this.$t(`thirdPartySoftware.${translationKey}`);
  }

  private async mounted(): Promise<void> {
    try {
      const response = await this.$digitalGiveawayClient.getOrder(this.$route.params.id);
      const i18nLocaleFromResponse = Localization.getI18nLocale(response.locale, response.market);
      this.$i18n.locale = i18nLocaleFromResponse;
      this.thirdPartySoftware = getLicenses();
    } catch (error) {
      console.log('Could not determine market. Displaying english imprint.');
    }
  }
}
